<template>
  <SysDataTableExpand
    v-if="FILTROS_STORE.grupos.length > 0"
    ref="sysDataTableRef"
    :height="alturaDaJanela - 222"
    :item-height="45"
    :headers="CABECALHOS_COMPUTED"
    :itemClass="cssLinha"
    :callbacks="CALLBACKS"
    @click:row="exportarDadosLinha"
    @callback-resetar-grid="fn => callbackResetarDadosGrid = fn"
  >
    <template v-for="(cabecalho, idx) in CABECALHOS_COMPUTED" #[`header.${cabecalho.value}`]>
      <div v-text="cabecalho.text" :key="idx" class="text-truncate" :class="cabecalho.css_header" />
    </template>

    <template #_item.descricao_analise="{item}">
      <div class="d-flex align-center">
        <DetalhesProduto 
          v-if="item.idproduto" 
          :produto="{ 
            id_grupo: item.idgrupo, 
            id_filial: 9999, 
            id_produto: item.idproduto, 
            produto_eh_combinacao: item.produto_combinado
          }" />
        <span v-text="item.descricao_analise" class="text-truncate" />
      </div>
    </template>

    <template #item.qtde_produtos="{item}">
      {{ item.idproduto ? '-' : item.qtde_produtos }}
    </template>

    <template #item.total_estoque_para_aumentar_preco_custo="{item}">
      <div class="text-truncate">
        <v-icon color="green" small>mdi-arrow-up</v-icon>
        {{ item.total_estoque_para_aumentar_preco_custo }}
      </div>
    </template>

    <template #item.total_estoque_para_reduzir_preco_custo="{item}">
      <div class="text-truncate">
        <v-icon color="red" small>mdi-arrow-down</v-icon>
        {{ item.total_estoque_para_reduzir_preco_custo }}
      </div>
    </template>

    <template #item.total_estoque_para_aumentar_quantidade="{item}">
      <div class="text-truncate">
        <v-icon color="green" small>mdi-arrow-up</v-icon>
        {{ item.total_estoque_para_aumentar_quantidade }}
      </div>
    </template>

    <template #item.total_estoque_para_reduzir_quantidade="{item}">
      <div class="text-truncate">
        <v-icon color="red" small>mdi-arrow-down</v-icon>
        {{ item.total_estoque_para_reduzir_quantidade }}
      </div>
    </template>
  </SysDataTableExpand>
</template>

<script>
import SysDataTableExpand from '@/components/utils/dataTable/sysDataTableExpand/Index'
import ResponsiveHeight from '@/helpers/ResponsiveHeight.js';
import {financeiro, quantitativo} from "@/components/Diagnostico/CurvasCruzadas/Cabecalhos";
import * as requisicoes from "@/api/Diagnostico/CurvasCruzadas";
import {formatarValor} from "@/helpers";
import DetalhesProduto from "@/components/produto/detalhes/Index.vue";
import isEqual from 'fast-deep-equal';

export default {
  name: "Tabela",
  components: {
    SysDataTableExpand,
    DetalhesProduto
  },
  mixins: [ResponsiveHeight],
  props: {
    coberturas_mudou_count: Number,
    tipo_visao: String
  },
  data: () => ({
    linha_clicada: null,
    callbackResetarDadosGrid: null
  }),
  computed: {
    CABECALHOS_COMPUTED() {
      if (this.tipo_visao === 'Q') return quantitativo;
      return financeiro;
    },
    FILTROS_STORE() {
      return this.$store.getters['filtrosUniversalAvancado/filtros_formatados'];
    },
    CALLBACKS() {
      const funcoes = [
        this.buscarAnaliseCruzadaPorCurvas,
        this.buscarAnaliseCruzadaPorCurvaCriticidade,
        this.buscarAnaliseCruzadaPorSegmento,
        this.buscarAnaliseCruzadaPorFornecedores,
        this.buscarAnaliseCruzadaPorProduto
      ];

      if (localStorage.diagnostico_ocultar_nivel_fornecedor === 'S') {
        return funcoes.filter(f => f !== this.buscarAnaliseCruzadaPorFornecedores);
      }

      return funcoes;
    }
  },
  watch: {
    coberturas_mudou_count() {
      this.callbackResetarDadosGrid();
    },
    FILTROS_STORE: {
      deep: true,
      handler(novo, antigo) {
        if (antigo.grupos.length === 0) return;
        // if (isEqual(novo, antigo)) return; octadesk #99904220
        this.callbackResetarDadosGrid();
      }
    }
  },
  methods: {
    async buscarAnaliseCruzadaPorCurvas() {
      const filtros = this.FILTROS_STORE;

      const linhas = await requisicoes.buscarAnaliseCruzadaPorCurvas(filtros);

      this.$refs.sysDataTableRef.linhas_expandidas = linhas.filter(linha => !linha.classificacao_criticidade && !linha.totalizador)

      const callback = linha => {
        linha.$nivel_linha = (linha.classificacao_criticidade) ? 1 : 0;

        if (linha.totalizador) {
          linha.$nao_expansivel = true;
        }

        return linha;
      };
      return this.formatarLinhas(linhas.map(callback));
    },
    async buscarAnaliseCruzadaPorCurvaCriticidade(linha) {
      const parametros = {
        classificacao_popularidade: linha.classificacao_popularidade,
        ...this.FILTROS_STORE
      };
      return this.formatarLinhas(await requisicoes.buscarAnaliseCruzadaPorCurvaCriticidade(parametros));
    },
    async buscarAnaliseCruzadaPorSegmento(linha) {
      const parametros = {
        classificacao_criticidade: linha.classificacao_criticidade,
        classificacao_popularidade: linha.classificacao_popularidade,
        ...this.FILTROS_STORE
      };
      return this.formatarLinhas(await requisicoes.buscarAnaliseCruzadaPorSegmento(parametros));
    },
    async buscarAnaliseCruzadaPorFornecedores(linha) {
      if (linha.descricao_analise === 'COMBINADOS') {
        linha.produto_combinado = true;
        return await this.buscarAnaliseCruzadaPorProduto(linha);
      }

      const parametros = {
        classificacao_criticidade: linha.classificacao_criticidade,
        classificacao_popularidade: linha.classificacao_popularidade,
        idsegmento: `${linha.idsegmento}`,
        ...this.FILTROS_STORE
      };

      return this.formatarLinhas(await requisicoes.buscarAnaliseCruzadaPorFornecedores(parametros));
    },
    async buscarAnaliseCruzadaPorProduto(linha) {
      const parametros = {
        classificacao_criticidade: linha.classificacao_criticidade,
        classificacao_popularidade: linha.classificacao_popularidade,
        idsegmento: `${linha.idsegmento}`,
        idfornecedor: localStorage.diagnostico_ocultar_nivel_fornecedor !== 'S' ? `${linha.idfornecedor || 0}` : null,
        produto_combinado: linha.produto_combinado ? 'S' : 'N',
        ...this.FILTROS_STORE
      };

      const itens = this.formatarLinhas(await requisicoes.buscarAnaliseCruzadaPorProduto(parametros));
      return itens.map(item => ({
        ...item,
        $nao_expansivel: linha.produto_combinado,
        produto_combinado: linha.produto_combinado,
      }));
    },
    formatarLinhas(linhas) {
      const callback = linha => {
        linha.qtde_produtos = formatarValor(linha.qtde_produtos);
        linha.cmm_em_preco_venda = `R$ ${formatarValor(linha.cmm_em_preco_venda)}`;
        linha.porcentual_projecao = `${formatarValor(linha.porcentual_projecao)}%`;
        linha.estoque_em_preco_custo = `R$ ${formatarValor(linha.estoque_em_preco_custo)}`;
        linha.cobertura_estoque = `${formatarValor(linha.cobertura_estoque)} dias`;
        linha.estoque_parametrizavel_preco_custo = `R$ ${formatarValor(linha.estoque_parametrizavel_preco_custo)}`;
        linha.cobertura_estoque_parametrizavel = `${formatarValor(linha.cobertura_estoque_parametrizavel)} dias`;
        linha.total_estoque_para_aumentar_preco_custo = `R$ ${formatarValor(linha.total_estoque_para_aumentar_preco_custo)}`;
        linha.total_estoque_para_reduzir_preco_custo = `R$ ${formatarValor(Math.abs(linha.total_estoque_para_reduzir_preco_custo))}`;

        linha.cmm_quantidade = formatarValor(linha.cmm_quantidade);
        linha.estoque_quantidade = formatarValor(linha.estoque_quantidade);
        linha.estoque_parametrizavel_quantidade = formatarValor(linha.estoque_parametrizavel_quantidade);
        linha.total_estoque_para_aumentar_quantidade = formatarValor(linha.total_estoque_para_aumentar_quantidade);
        linha.total_estoque_para_reduzir_quantidade = formatarValor(Math.abs(linha.total_estoque_para_reduzir_quantidade));

        linha.sugestao_compra_quantidade = formatarValor(Math.abs(linha.sugestao_compra_quantidade));
        linha.sugestao_compra_preco_custo = `R$ ${formatarValor(linha.sugestao_compra_preco_custo)}`;

        return linha;
      }

      return linhas.map(callback);
    },
    exportarDadosLinha({ row }) {
      if (this.linha_clicada === row) {
        this.$emit('duplo-click:linha', {...row});
      }

      this.linha_clicada = row;
      setTimeout(() => this.linha_clicada = null, 500);
    },
    cssLinha(linha) {
      return {
        'font-weight-bold': linha.totalizador,
        'cursor-pointer': true
      }
    }
  }
}
</script>

<style scoped>
.ghjkl{
  background: #d9d8d8;
}
</style>
